import countries from '../countries-caribbean.json'

const countryCodeToCountry = (code) => countries.find(x => x.code.toLowerCase() === code ).name;

export default countryCodeToCountry;